// Importar configuración de producción
import PRODUCTION_CONFIG from '../config/production.js';

// Determinar la URL de la API basada en el entorno
const API_URL = process.env.NODE_ENV === 'production' 
  ? PRODUCTION_CONFIG.API_BASE_URL 
  : (process.env.REACT_APP_API_URL || 'http://localhost:3001/api');

console.log('🌐 API URL configurada:', API_URL);
console.log('🔧 Entorno:', process.env.NODE_ENV);

const headers = {
  'Content-Type': 'application/json',
};

// ==================== FUNCIONES DE AUTENTICACIÓN ====================

export const loginUser = async (email, password) => {
  try {
    const response = await fetch(`${API_URL}/auth/login`, {
      method: 'POST',
      headers,
      body: JSON.stringify({ email, password }),
    });
    if (!response.ok) throw new Error('Credenciales inválidas');
    return await response.json();
  } catch (error) {
    console.error('Error en login:', error);
    throw error;
  }
};

// ==================== FUNCIONES DE USUARIOS ====================

export const loadUsers = async () => {
  try {
    const response = await fetch(`${API_URL}/users`);
    if (!response.ok) throw new Error('Error al cargar usuarios');
    return await response.json();
  } catch (error) {
    console.error('Error al cargar usuarios:', error);
    throw error;
  }
};

export const createUser = async (user) => {
  try {
    console.log('=== FRONTEND createUser ===');
    console.log('createUser - datos originales:', JSON.stringify(user));
    console.log('createUser - cells originales:', JSON.stringify(user.cells), 'tipo:', typeof user.cells);
    
    // Procesar el array de células antes de enviarlo al servidor
    const processedUser = { ...user };
    
    if (processedUser.cells) {
      console.log('createUser - procesando cells');
      // Convertir el array de células a una cadena simple separada por comas
      if (Array.isArray(processedUser.cells)) {
        console.log('createUser - cells es array, procesando');
        processedUser.cells = processedUser.cells
          .filter(cell => cell && typeof cell === 'string' && cell.trim())
          .map(cell => cell.trim())
          .join(',');
        console.log('createUser - cells después de join:', processedUser.cells);
      } else if (typeof processedUser.cells === 'string') {
        console.log('createUser - cells es string, limpiando');
        // Si ya es un string, limpiarlo
        processedUser.cells = processedUser.cells.trim();
      } else {
        console.log('createUser - cells es otro tipo, estableciendo vacío');
        processedUser.cells = '';
      }
      
      // Si está vacío, establecer como null
      if (!processedUser.cells) {
        console.log('createUser - cells vacío, estableciendo null');
        processedUser.cells = null;
      }
    }
    
    console.log('createUser - datos procesados:', JSON.stringify(processedUser));
    console.log('createUser - cells final:', JSON.stringify(processedUser.cells));
    
    const response = await fetch(`${API_URL}/users`, {
      method: 'POST',
      headers,
      body: JSON.stringify(processedUser),
    });
    if (!response.ok) throw new Error('Error al crear usuario');
    return await response.json();
  } catch (error) {
    console.error('Error al crear usuario:', error);
    throw error;
  }
};

export const updateUser = async (email, updates) => {
  try {
    console.log('=== FRONTEND updateUser ===');
    console.log('updateUser - datos originales:', JSON.stringify(updates));
    console.log('updateUser - cells originales:', JSON.stringify(updates.cells), 'tipo:', typeof updates.cells);
    
    // Procesar el array de células antes de enviarlo al servidor
    const processedUpdates = { ...updates };
    
    if (processedUpdates.cells) {
      console.log('updateUser - procesando cells');
      // Convertir el array de células a una cadena simple separada por comas
      if (Array.isArray(processedUpdates.cells)) {
        console.log('updateUser - cells es array, procesando');
        processedUpdates.cells = processedUpdates.cells
          .filter(cell => cell && typeof cell === 'string' && cell.trim())
          .map(cell => cell.trim())
          .join(',');
        console.log('updateUser - cells después de join:', processedUpdates.cells);
      } else if (typeof processedUpdates.cells === 'string') {
        console.log('updateUser - cells es string, limpiando');
        // Si ya es un string, limpiarlo
        processedUpdates.cells = processedUpdates.cells.trim();
      } else {
        console.log('updateUser - cells es otro tipo, estableciendo vacío');
        processedUpdates.cells = '';
      }
      
      // Si está vacío, establecer como null
      if (!processedUpdates.cells) {
        console.log('updateUser - cells vacío, estableciendo null');
        processedUpdates.cells = null;
      }
    }
    
    console.log('updateUser - datos procesados:', JSON.stringify(processedUpdates));
    console.log('updateUser - cells final:', JSON.stringify(processedUpdates.cells));
    
    const response = await fetch(`${API_URL}/users/${email}`, {
      method: 'PUT',
      headers,
      body: JSON.stringify(processedUpdates),
    });
    if (!response.ok) throw new Error('Error al actualizar usuario');
    return await response.json();
  } catch (error) {
    console.error('Error al actualizar usuario:', error);
    throw error;
  }
};

export const deleteUser = async (email) => {
  try {
    const response = await fetch(`${API_URL}/users/${email}`, {
      method: 'DELETE',
      headers,
    });
    if (!response.ok) throw new Error('Error al eliminar usuario');
    return await response.json();
  } catch (error) {
    console.error('Error al eliminar usuario:', error);
    throw error;
  }
};

export const changePassword = async (email, newPassword, currentPassword = null) => {
  try {
    const body = { newPassword };
    
    // Solo incluir currentPassword si se proporciona (para cambios de contraseña del usuario)
    if (currentPassword) {
      body.currentPassword = currentPassword;
    }
    
    const response = await fetch(`${API_URL}/users/${email}/password`, {
      method: 'PUT',
      headers,
      body: JSON.stringify(body),
    });
    
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.error || 'Error al cambiar contraseña');
    }
    
    return data;
  } catch (error) {
    console.error('Error al cambiar contraseña:', error);
    throw error;
  }
};

export const resetPassword = async (email, newPassword, adminEmail) => {
  try {
    const response = await fetch(`${API_URL}/users/${email}/reset-password`, {
      method: 'PUT',
      headers,
      body: JSON.stringify({ newPassword, adminEmail }),
    });
    
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.error || 'Error al resetear contraseña');
    }
    
    return data;
  } catch (error) {
    console.error('Error al resetear contraseña:', error);
    throw error;
  }
};

// ==================== FUNCIONES DE CLIENTES ====================

export const loadClients = async (userCells = null, salesExecutive = null) => {
  try {
    let url = `${API_URL}/clients`;
    const params = [];

    // Si se proporcionan células del usuario, agregarlas como parámetro de consulta
    if (userCells && userCells.length > 0) {
      const cellsParam = userCells.join(',');
      params.push(`userCells=${encodeURIComponent(cellsParam)}`);
      console.log('🔍 Frontend - Cargando clientes con filtro de células:', cellsParam);
    }

    // Si se proporciona ejecutivo, agregar como parámetro de consulta
    if (salesExecutive) {
      params.push(`salesExecutive=${encodeURIComponent(salesExecutive)}`);
      console.log('🔍 Frontend - Cargando clientes con filtro de ejecutivo:', salesExecutive);
    }

    if (params.length > 0) {
      url += `?${params.join('&')}`;
    } else {
      console.log('🔍 Frontend - Cargando todos los clientes (sin filtro)');
    }

    const response = await fetch(url);
    if (!response.ok) throw new Error('Error al cargar clientes');
    const clients = await response.json();

    console.log('🔍 Frontend - Clientes recibidos:', clients.length);
    console.log('🔍 Frontend - Nombres de clientes:', clients.map(c => c.name));

    return clients;
  } catch (error) {
    console.error('Error al cargar clientes:', error);
    throw error;
  }
};

export const createClient = async (client) => {
  try {
    const response = await fetch(`${API_URL}/clients`, {
      method: 'POST',
      headers,
      body: JSON.stringify(client),
    });
    if (!response.ok) throw new Error('Error al crear cliente');
    return await response.json();
  } catch (error) {
    console.error('Error al crear cliente:', error);
    throw error;
  }
};

export const updateClient = async (id, updates) => {
  try {
    const response = await fetch(`${API_URL}/clients/${id}`, {
      method: 'PUT',
      headers,
      body: JSON.stringify(updates),
    });
    if (!response.ok) throw new Error('Error al actualizar cliente');
    return await response.json();
  } catch (error) {
    console.error('Error al actualizar cliente:', error);
    throw error;
  }
};

export const deleteClient = async (id) => {
  try {
    const response = await fetch(`${API_URL}/clients/${id}`, {
      method: 'DELETE',
      headers,
    });
    if (!response.ok) throw new Error('Error al eliminar cliente');
    return await response.json();
  } catch (error) {
    console.error('Error al eliminar cliente:', error);
    throw error;
  }
};

// ==================== FUNCIONES DE JUNTAS ====================

export const createMeeting = async (meeting) => {
  try {
    const response = await fetch(`${API_URL}/meetings`, {
      method: 'POST',
      headers,
      body: JSON.stringify(meeting),
    });
    if (!response.ok) throw new Error('Error al crear junta');
    return await response.json();
  } catch (error) {
    console.error('Error al crear junta:', error);
    throw error;
  }
};

export const updateMeeting = async (id, updates) => {
  try {
    const response = await fetch(`${API_URL}/meetings/${id}`, {
      method: 'PUT',
      headers,
      body: JSON.stringify(updates),
    });
    if (!response.ok) throw new Error('Error al actualizar junta');
    return await response.json();
  } catch (error) {
    console.error('Error al actualizar junta:', error);
    throw error;
  }
};

export const deleteMeeting = async (id) => {
  try {
    const response = await fetch(`${API_URL}/meetings/${id}`, {
      method: 'DELETE',
      headers,
    });
    if (!response.ok) throw new Error('Error al eliminar junta');
    return await response.json();
  } catch (error) {
    console.error('Error al eliminar junta:', error);
    throw error;
  }
};

// ==================== FUNCIONES DE TAREAS ====================

export const loadTasks = async (userCells = null, userRole = null) => {
  try {
    let url = `${API_URL}/tasks`;
    const params = new URLSearchParams();
    
    // Si se proporcionan células del usuario, agregarlas como parámetro de consulta
    if (userCells && userCells.length > 0) {
      const cellsParam = userCells.join(',');
      params.append('userCells', cellsParam);
      console.log('🔍 Frontend - Cargando tareas con filtro de células:', cellsParam);
    }
    
    // Agregar el rol del usuario
    if (userRole) {
      params.append('userRole', userRole);
      console.log('🔍 Frontend - Rol del usuario:', userRole);
    }
    
    // Construir URL con parámetros si existen
    if (params.toString()) {
      url += `?${params.toString()}`;
    }
    
    console.log('🔍 Frontend - URL final:', url);
    
    const response = await fetch(url);
    if (!response.ok) throw new Error('Error al cargar tareas');
    const tasks = await response.json();
    
    console.log('🔍 Frontend - Tareas recibidas:', tasks.length);
    
    return tasks;
  } catch (error) {
    console.error('Error al cargar tareas:', error);
    throw error;
  }
};

export const createTask = async (task) => {
  try {
    // Verificar si task es una instancia de FormData
    const isFormData = task instanceof FormData;
    
    // Configurar headers y body según el tipo de datos
    const requestOptions = {
      method: 'POST',
      headers: isFormData ? {} : headers, // No incluir Content-Type para FormData
      body: isFormData ? task : JSON.stringify(task),
    };
    
    console.log('🚀 createTask - Tipo de datos:', isFormData ? 'FormData' : 'JSON');
    
    const response = await fetch(`${API_URL}/tasks`, requestOptions);
    if (!response.ok) throw new Error('Error al crear tarea');
    return await response.json();
  } catch (error) {
    console.error('Error al crear tarea:', error);
    throw error;
  }
};

export const updateTask = async (id, updates) => {
  try {
    const response = await fetch(`${API_URL}/tasks/${id}`, {
      method: 'PUT',
      headers,
      body: JSON.stringify(updates),
    });
    if (!response.ok) throw new Error('Error al actualizar tarea');
    return await response.json();
  } catch (error) {
    console.error('Error al actualizar tarea:', error);
    throw error;
  }
};

export const deleteTask = async (id) => {
  try {
    const response = await fetch(`${API_URL}/tasks/${id}`, {
      method: 'DELETE',
      headers,
    });
    if (!response.ok) throw new Error('Error al eliminar tarea');
    return await response.json();
  } catch (error) {
    console.error('Error al eliminar tarea:', error);
    throw error;
  }
};

// ==================== FUNCIONES DE OPERACIONES DE PRESUPUESTO ====================

export const loadBudgetOperations = async (userCells = null, userRole = null, userEmail = null) => {
  try {
    let url = `${API_URL}/budget-operations`;
    const params = new URLSearchParams();
    
    // Si se proporcionan células del usuario, agregarlas como parámetro de consulta
    if (userCells && userCells.length > 0) {
      const cellsParam = userCells.join(',');
      params.append('userCells', cellsParam);
      console.log('🔍 Frontend - Cargando operaciones de presupuesto con filtro de células:', cellsParam);
    }
    
    // Agregar el rol del usuario
    if (userRole) {
      params.append('userRole', userRole);
      console.log('🔍 Frontend - Rol del usuario:', userRole);
    }
    
    // Agregar el email del usuario para filtrado por agente asignado
    if (userEmail) {
      params.append('userEmail', userEmail);
      console.log('🔍 Frontend - Email del usuario:', userEmail);
    }
    
    // Construir URL con parámetros si existen
    if (params.toString()) {
      url += `?${params.toString()}`;
    } else {
      console.log('🔍 Frontend - Cargando todas las operaciones de presupuesto (sin filtro)');
    }
    
    console.log('🔍 Frontend - URL final:', url);
    
    const response = await fetch(url);
    if (!response.ok) throw new Error('Error al cargar operaciones de presupuesto');
    const operations = await response.json();
    
    console.log('🔍 Frontend - Operaciones de presupuesto recibidas:', operations.length);
    
    return operations;
  } catch (error) {
    console.error('Error al cargar operaciones de presupuesto:', error);
    throw error;
  }
};

export const createBudgetOperation = async (operation) => {
  try {
    // Procesar fechas de aumento antes de enviar
    const processedOperation = { ...operation };
    
    if (processedOperation.fechas_aumento) {
      // Filtrar fechas vacías y formatear
      processedOperation.fechas_aumento = processedOperation.fechas_aumento
        .filter(fecha => fecha)
        .map(fecha => fecha.split('T')[0]); // Asegurar formato YYYY-MM-DD
    }

    const response = await fetch(`${API_URL}/budget-operations`, {
      method: 'POST',
      headers,
      body: JSON.stringify(processedOperation),
    });
    if (!response.ok) throw new Error('Error al crear operación de presupuesto');
    return await response.json();
  } catch (error) {
    console.error('Error al crear operación de presupuesto:', error);
    throw error;
  }
};

export const updateBudgetOperation = async (id, updates) => {
  try {
    // Procesar fechas de aumento antes de enviar
    const processedUpdates = { ...updates };
    
    if (processedUpdates.fechas_aumento) {
      // Filtrar fechas vacías y formatear
      processedUpdates.fechas_aumento = processedUpdates.fechas_aumento
        .filter(fecha => fecha)
        .map(fecha => fecha.split('T')[0]); // Asegurar formato YYYY-MM-DD
    }

    const response = await fetch(`${API_URL}/budget-operations/${id}`, {
      method: 'PUT',
      headers,
      body: JSON.stringify(processedUpdates),
    });
    if (!response.ok) throw new Error('Error al actualizar operación de presupuesto');
    return await response.json();
  } catch (error) {
    console.error('Error al actualizar operación de presupuesto:', error);
    throw error;
  }
};

export const deleteBudgetOperation = async (id) => {
  try {
    const response = await fetch(`${API_URL}/budget-operations/${id}`, {
      method: 'DELETE',
      headers,
    });
    if (!response.ok) throw new Error('Error al eliminar operación de presupuesto');
    return await response.json();
  } catch (error) {
    console.error('Error al eliminar operación de presupuesto:', error);
    throw error;
  }
};

// ==================== FUNCIONES DE HISTORIAL DE OPERACIONES ====================

export const getBudgetOperationHistory = async (operationId) => {
  try {
    const response = await fetch(`${API_URL}/budget-operations/${operationId}/history`);
    if (!response.ok) throw new Error('Error al obtener historial de operación');
    return await response.json();
  } catch (error) {
    console.error('Error al obtener historial de operación:', error);
    throw error;
  }
};

export const addBudgetOperationHistoryEntry = async (operationId, entry) => {
  try {
    const response = await fetch(`${API_URL}/budget-operations/${operationId}/history`, {
      method: 'POST',
      headers,
      body: JSON.stringify(entry),
    });
    if (!response.ok) throw new Error('Error al agregar entrada al historial');
    return await response.json();
  } catch (error) {
    console.error('Error al agregar entrada al historial:', error);
    throw error;
  }
};

export const getBudgetOperationsByClient = async (clientName) => {
  try {
    const response = await fetch(`${API_URL}/budget-operations/client/${encodeURIComponent(clientName)}`);
    if (!response.ok) throw new Error('Error al obtener operaciones del cliente');
    return await response.json();
  } catch (error) {
    console.error('Error al obtener operaciones del cliente:', error);
    throw error;
  }
};

// ==================== FUNCIONES DE COMPLETADO DE OPERACIONES ====================

export const completeBudgetOperation = async (operationId, userName) => {
  try {
    const response = await fetch(`${API_URL}/budget-operations/${operationId}/complete`, {
      method: 'PUT',
      headers,
      body: JSON.stringify({ user_name: userName }),
    });
    if (!response.ok) throw new Error('Error al marcar operación como completada');
    return await response.json();
  } catch (error) {
    console.error('Error al marcar operación como completada:', error);
    throw error;
  }
};

export const uncompleteBudgetOperation = async (operationId, userName) => {
  try {
    const response = await fetch(`${API_URL}/budget-operations/${operationId}/uncomplete`, {
      method: 'PUT',
      headers,
      body: JSON.stringify({ user_name: userName }),
    });
    if (!response.ok) throw new Error('Error al marcar operación como pendiente');
    return await response.json();
  } catch (error) {
    console.error('Error al marcar operación como pendiente:', error);
    throw error;
  }
};

export const getCompletedBudgetOperations = async () => {
  try {
    const response = await fetch(`${API_URL}/budget-operations/completed`);
    if (!response.ok) throw new Error('Error al obtener operaciones completadas');
    return await response.json();
  } catch (error) {
    console.error('Error al obtener operaciones completadas:', error);
    throw error;
  }
};

export const getPendingBudgetOperations = async () => {
  try {
    const response = await fetch(`${API_URL}/budget-operations/pending`);
    if (!response.ok) throw new Error('Error al obtener operaciones pendientes');
    return await response.json();
  } catch (error) {
    console.error('Error al obtener operaciones pendientes:', error);
    throw error;
  }
};

// ==================== FUNCIONES DE SEGUIMIENTO DE CAMPAÑAS ====================

export const loadCampaignTracking = async (userCells = null, userRole = null, userEmail = null) => {
  try {
    let url = `${API_URL}/campaign-tracking`;
    const params = new URLSearchParams();
    
    // Si se proporcionan células del usuario, agregarlas como parámetro de consulta
    if (userCells && userCells.length > 0) {
      const cellsParam = userCells.join(',');
      params.append('userCells', cellsParam);
      console.log('🔍 Frontend - Cargando campaign-tracking con filtro de células:', cellsParam);
    }
    
    // Agregar el rol del usuario
    if (userRole) {
      params.append('userRole', userRole);
      console.log('🔍 Frontend - Rol del usuario:', userRole);
    }
    
    // Agregar el email del usuario para filtrado por agente asignado
    if (userEmail) {
      params.append('userEmail', userEmail);
      console.log('🔍 Frontend - Email del usuario:', userEmail);
    }
    
    // Construir URL con parámetros si existen
    if (params.toString()) {
      url += `?${params.toString()}`;
    }
    
    console.log('🔍 Frontend - URL final:', url);
    
    const response = await fetch(url);
    if (!response.ok) throw new Error('Error al cargar seguimiento de campañas');
    const campaigns = await response.json();
    
    console.log('🔍 Frontend - Campañas recibidas:', campaigns.length);
    
    return campaigns;
  } catch (error) {
    console.error('Error al cargar seguimiento de campañas:', error);
    throw error;
  }
};

export const createCampaignTracking = async (campaign) => {
  try {
    const response = await fetch(`${API_URL}/campaign-tracking`, {
      method: 'POST',
      headers,
      body: JSON.stringify(campaign),
    });
    if (!response.ok) throw new Error('Error al crear seguimiento de campaña');
    return await response.json();
  } catch (error) {
    console.error('Error al crear seguimiento de campaña:', error);
    throw error;
  }
};

export const updateCampaignTracking = async (id, updates) => {
  try {
    console.log('🔄 updateCampaignTracking - ID:', id);
    console.log('🔄 updateCampaignTracking - Updates:', JSON.stringify(updates, null, 2));
    
    // Procesar fechas para asegurar formato correcto
    const processedUpdates = { ...updates };
    
    // Convertir fecha_asunto a formato YYYY-MM-DD si es necesario
    if (processedUpdates.fecha_asunto) {
      try {
        const date = new Date(processedUpdates.fecha_asunto);
        if (!isNaN(date.getTime())) {
          processedUpdates.fecha_asunto = date.toISOString().slice(0, 10);
        }
      } catch (dateError) {
        console.warn('⚠️ Error procesando fecha_asunto:', dateError);
      }
    }
    
    console.log('🔄 updateCampaignTracking - Datos procesados:', JSON.stringify(processedUpdates, null, 2));
    
    const response = await fetch(`${API_URL}/campaign-tracking/${id}`, {
      method: 'PUT',
      headers,
      body: JSON.stringify(processedUpdates),
    });
    
    console.log('📡 updateCampaignTracking - Status:', response.status);
    
    if (!response.ok) {
      const errorText = await response.text();
      console.error('❌ updateCampaignTracking - Error response:', errorText);
      throw new Error(`Error al actualizar seguimiento de campaña: ${response.status} - ${errorText}`);
    }
    
    const result = await response.json();
    console.log('✅ updateCampaignTracking - Resultado:', result);
    return result;
  } catch (error) {
    console.error('❌ Error al actualizar seguimiento de campaña:', error);
    throw error;
  }
};

export const deleteCampaignTracking = async (id) => {
  try {
    const response = await fetch(`${API_URL}/campaign-tracking/${id}`, {
      method: 'DELETE',
      headers,
    });
    if (!response.ok) throw new Error('Error al eliminar seguimiento de campaña');
    return await response.json();
  } catch (error) {
    console.error('Error al eliminar seguimiento de campaña:', error);
    throw error;
  }
};

// ==================== FUNCIONES DE CARGA CON FILTRADO POR CÉLULAS ====================

export const loadBalanceReduction = async (userCells = null, userRole = null, userEmail = null) => {
  try {
    let url = `${API_URL}/balance-reduction`;
    const params = new URLSearchParams();
    
    // Si se proporcionan células del usuario, agregarlas como parámetro de consulta
    if (userCells && userCells.length > 0) {
      const cellsParam = userCells.join(',');
      params.append('userCells', cellsParam);
      console.log('🔍 Frontend - Cargando balance-reduction con filtro de células:', cellsParam);
    }
    
    // Agregar el rol del usuario
    if (userRole) {
      params.append('userRole', userRole);
      console.log('🔍 Frontend - Rol del usuario:', userRole);
    }
    
    // Agregar el email del usuario para filtrado por agente asignado
    if (userEmail) {
      params.append('userEmail', userEmail);
      console.log('🔍 Frontend - Email del usuario:', userEmail);
    }
    
    // Construir URL con parámetros si existen
    if (params.toString()) {
      url += `?${params.toString()}`;
    }
    
    console.log('🔍 Frontend - URL final:', url);
    
    const response = await fetch(url);
    if (!response.ok) throw new Error('Error al cargar balance-reduction');
    const records = await response.json();
    
    console.log('🔍 Frontend - Registros recibidos:', records.length);
    
    return records;
  } catch (error) {
    console.error('Error al cargar balance-reduction:', error);
    throw error;
  }
};

export const loadNoContactClients = async (userCells = null, userRole = null) => {
  try {
    let url = `${API_URL}/no-contact-clients`;
    const params = new URLSearchParams();
    
    // Si se proporcionan células del usuario, agregarlas como parámetro de consulta
    if (userCells && userCells.length > 0) {
      const cellsParam = userCells.join(',');
      params.append('userCells', cellsParam);
      console.log('🔍 Frontend - Cargando no-contact-clients con filtro de células:', cellsParam);
    }
    
    // Agregar el rol del usuario
    if (userRole) {
      params.append('userRole', userRole);
      console.log('🔍 Frontend - Rol del usuario:', userRole);
    }
    
    // Construir URL con parámetros si existen
    if (params.toString()) {
      url += `?${params.toString()}`;
    }
    
    console.log('🔍 Frontend - URL final:', url);
    
    const response = await fetch(url);
    if (!response.ok) throw new Error('Error al cargar no-contact-clients');
    const records = await response.json();
    
    console.log('🔍 Frontend - Registros recibidos:', records.length);
    
    return records;
  } catch (error) {
    console.error('Error al cargar no-contact-clients:', error);
    throw error;
  }
};

export const loadNoTrafficClients = async (userCells = null, userRole = null, userEmail = null) => {
  try {
    let url = `${API_URL}/no-traffic-clients`;
    const params = new URLSearchParams();
    
    // Si se proporcionan células del usuario, agregarlas como parámetro de consulta
    if (userCells && userCells.length > 0) {
      const cellsParam = userCells.join(',');
      params.append('userCells', cellsParam);
      console.log('🔍 Frontend - Cargando no-traffic-clients con filtro de células:', cellsParam);
    }
    
    // Agregar el rol del usuario
    if (userRole) {
      params.append('userRole', userRole);
      console.log('🔍 Frontend - Rol del usuario:', userRole);
    }
    
    // Agregar el email del usuario para filtrado por agente asignado
    if (userEmail) {
      params.append('userEmail', userEmail);
      console.log('🔍 Frontend - Email del usuario:', userEmail);
    }
    
    // Construir URL con parámetros si existen
    if (params.toString()) {
      url += `?${params.toString()}`;
    }
    
    console.log('🔍 Frontend - URL final:', url);
    
    const response = await fetch(url);
    if (!response.ok) throw new Error('Error al cargar no-traffic-clients');
    const records = await response.json();
    
    console.log('🔍 Frontend - Registros recibidos:', records.length);
    
    return records;
  } catch (error) {
    console.error('Error al cargar no-traffic-clients:', error);
    throw error;
  }
};

export const loadExcessJunkClients = async (userCells = null, userRole = null, userEmail = null) => {
  try {
    let url = `${API_URL}/excess-junk-clients`;
    const params = new URLSearchParams();
    
    // Si se proporcionan células del usuario, agregarlas como parámetro de consulta
    if (userCells && userCells.length > 0) {
      const cellsParam = userCells.join(',');
      params.append('userCells', cellsParam);
      console.log('🔍 Frontend - Cargando excess-junk-clients con filtro de células:', cellsParam);
    }
    
    // Agregar el rol del usuario
    if (userRole) {
      params.append('userRole', userRole);
      console.log('🔍 Frontend - Rol del usuario:', userRole);
    }
    
    // Agregar el email del usuario para filtrado por agente asignado
    if (userEmail) {
      params.append('userEmail', userEmail);
      console.log('🔍 Frontend - Email del usuario:', userEmail);
    }
    
    // Construir URL con parámetros si existen
    if (params.toString()) {
      url += `?${params.toString()}`;
    }
    
    console.log('🔍 Frontend - URL final:', url);
    
    const response = await fetch(url);
    if (!response.ok) throw new Error('Error al cargar excess-junk-clients');
    const records = await response.json();
    
    console.log('🔍 Frontend - Registros recibidos:', records.length);
    
    return records;
  } catch (error) {
    console.error('Error al cargar excess-junk-clients:', error);
    throw error;
  }
};

export const loadCpcTrafficClients = async (userCells = null, userRole = null, userEmail = null) => {
  try {
    let url = `${API_URL}/cpc-traffic-clients`;
    const params = new URLSearchParams();
    
    // Si se proporcionan células del usuario, agregarlas como parámetro de consulta
    if (userCells && userCells.length > 0) {
      const cellsParam = userCells.join(',');
      params.append('userCells', cellsParam);
      console.log('🔍 Frontend - Cargando cpc-traffic-clients con filtro de células:', cellsParam);
    }
    
    // Agregar el rol del usuario
    if (userRole) {
      params.append('userRole', userRole);
      console.log('🔍 Frontend - Rol del usuario:', userRole);
    }
    
    // Agregar el email del usuario para filtrado por agente asignado
    if (userEmail) {
      params.append('userEmail', userEmail);
      console.log('🔍 Frontend - Email del usuario:', userEmail);
    }
    
    // Construir URL con parámetros si existen
    if (params.toString()) {
      url += `?${params.toString()}`;
    }
    
    console.log('🔍 Frontend - URL final:', url);
    
    const response = await fetch(url);
    if (!response.ok) throw new Error('Error al cargar cpc-traffic-clients');
    const records = await response.json();
    
    console.log('🔍 Frontend - Registros recibidos:', records.length);
    
    return records;
  } catch (error) {
    console.error('Error al cargar cpc-traffic-clients:', error);
    throw error;
  }
};

export const loadConversionDrops = async (userCells = null, userRole = null, userEmail = null) => {
  try {
    let url = `${API_URL}/conversion-drops`;
    const params = new URLSearchParams();
    
    // Si se proporcionan células del usuario, agregarlas como parámetro de consulta
    if (userCells && userCells.length > 0) {
      const cellsParam = userCells.join(',');
      params.append('userCells', cellsParam);
      console.log('🔍 Frontend - Cargando conversion-drops con filtro de células:', cellsParam);
    }
    
    // Agregar el rol del usuario
    if (userRole) {
      params.append('userRole', userRole);
      console.log('🔍 Frontend - Rol del usuario:', userRole);
    }
    
    // Agregar el email del usuario para filtrado por agente asignado
    if (userEmail) {
      params.append('userEmail', userEmail);
      console.log('🔍 Frontend - Email del usuario:', userEmail);
    }
    
    // Construir URL con parámetros si existen
    if (params.toString()) {
      url += `?${params.toString()}`;
    }
    
    console.log('🔍 Frontend - URL final:', url);
    
    const response = await fetch(url);
    if (!response.ok) throw new Error('Error al cargar conversion-drops');
    const records = await response.json();
    
    console.log('🔍 Frontend - Registros recibidos:', records.length);
    
    return records;
  } catch (error) {
    console.error('Error al cargar conversion-drops:', error);
    throw error;
  }
};

export const loadVerifications = async (userCells = null, userRole = null, userEmail = null) => {
  try {
    let url = `${API_URL}/verifications`;
    const params = new URLSearchParams();
    
    // Si se proporcionan células del usuario, agregarlas como parámetro de consulta
    if (userCells && userCells.length > 0) {
      const cellsParam = userCells.join(',');
      params.append('userCells', cellsParam);
      console.log('🔍 Frontend - Cargando verifications con filtro de células:', cellsParam);
    }
    
    // Agregar el rol del usuario
    if (userRole) {
      params.append('userRole', userRole);
      console.log('🔍 Frontend - Rol del usuario:', userRole);
    }
    
    // Agregar el email del usuario para filtrado por agente asignado
    if (userEmail) {
      params.append('userEmail', userEmail);
      console.log('🔍 Frontend - Email del usuario:', userEmail);
    }
    
    // Construir URL con parámetros si existen
    if (params.toString()) {
      url += `?${params.toString()}`;
    }
    
    console.log('🔍 Frontend - URL final:', url);
    
    const response = await fetch(url);
    if (!response.ok) throw new Error('Error al cargar verifications');
    const records = await response.json();
    
    console.log('🔍 Frontend - Registros recibidos:', records.length);
    
    return records;
  } catch (error) {
    console.error('Error al cargar verifications:', error);
    throw error;
  }
};

export const loadNoAnswerClients = async (userCells = null, userRole = null, userEmail = null) => {
  try {
    let url = `${API_URL}/no-answer-clients`;
    const params = new URLSearchParams();
    
    // Si se proporcionan células del usuario, agregarlas como parámetro de consulta
    if (userCells && userCells.length > 0) {
      const cellsParam = userCells.join(',');
      params.append('userCells', cellsParam);
      console.log('🔍 Frontend - Cargando no-answer-clients con filtro de células:', cellsParam);
    }
    
    // Agregar el rol del usuario
    if (userRole) {
      params.append('userRole', userRole);
      console.log('🔍 Frontend - Rol del usuario:', userRole);
    }
    
    // Agregar el email del usuario para filtrado por agente asignado
    if (userEmail) {
      params.append('userEmail', userEmail);
      console.log('🔍 Frontend - Email del usuario:', userEmail);
    }
    
    // Construir URL con parámetros si existen
    if (params.toString()) {
      url += `?${params.toString()}`;
    }
    
    console.log('🔍 Frontend - URL final:', url);
    
    const response = await fetch(url);
    if (!response.ok) throw new Error('Error al cargar no-answer-clients');
    const records = await response.json();
    
    console.log('🔍 Frontend - Registros recibidos:', records.length);
    
    return records;
  } catch (error) {
    console.error('Error al cargar no-answer-clients:', error);
    throw error;
  }
};

export const loadMetaBudgetIncrease = async (userCells = null, userRole = null) => {
  try {
    let url = `${API_URL}/meta-budget-increase`;
    const params = new URLSearchParams();
    
    // Si se proporcionan células del usuario, agregarlas como parámetro de consulta
    if (userCells && userCells.length > 0) {
      const cellsParam = userCells.join(',');
      params.append('userCells', cellsParam);
      console.log('🔍 Frontend - Cargando meta-budget-increase con filtro de células:', cellsParam);
    }
    
    // Agregar el rol del usuario
    if (userRole) {
      params.append('userRole', userRole);
      console.log('🔍 Frontend - Rol del usuario:', userRole);
    }
    
    // Construir URL con parámetros si existen
    if (params.toString()) {
      url += `?${params.toString()}`;
    }
    
    console.log('🔍 Frontend - URL final:', url);
    
    const response = await fetch(url);
    if (!response.ok) throw new Error('Error al cargar meta-budget-increase');
    const records = await response.json();
    
    console.log('🔍 Frontend - Registros recibidos:', records.length);
    
    return records;
  } catch (error) {
    console.error('Error al cargar meta-budget-increase:', error);
    throw error;
  }
};

export const loadMetaCampaignTracking = async (userCells = null, userRole = null) => {
  try {
    let url = `${API_URL}/meta-campaign-tracking`;
    const params = new URLSearchParams();
    
    // Si se proporcionan células del usuario, agregarlas como parámetro de consulta
    if (userCells && userCells.length > 0) {
      const cellsParam = userCells.join(',');
      params.append('userCells', cellsParam);
      console.log('🔍 Frontend - Cargando meta-campaign-tracking con filtro de células:', cellsParam);
    }
    
    // Agregar el rol del usuario
    if (userRole) {
      params.append('userRole', userRole);
      console.log('🔍 Frontend - Rol del usuario:', userRole);
    }
    
    // Construir URL con parámetros si existen
    if (params.toString()) {
      url += `?${params.toString()}`;
    }
    
    console.log('🔍 Frontend - URL final:', url);
    
    const response = await fetch(url);
    if (!response.ok) throw new Error('Error al cargar meta-campaign-tracking');
    const records = await response.json();
    
    console.log('🔍 Frontend - Registros recibidos:', records.length);
    
    return records;
  } catch (error) {
    console.error('Error al cargar meta-campaign-tracking:', error);
    throw error;
  }
};

export const loadMetaBalanceReduction = async (userCells = null, userRole = null) => {
  try {
    let url = `${API_URL}/meta-balance-reduction`;
    const params = new URLSearchParams();
    
    // Si se proporcionan células del usuario, agregarlas como parámetro de consulta
    if (userCells && userCells.length > 0) {
      const cellsParam = userCells.join(',');
      params.append('userCells', cellsParam);
      console.log('🔍 Frontend - Cargando meta-balance-reduction con filtro de células:', cellsParam);
    }
    
    // Agregar el rol del usuario
    if (userRole) {
      params.append('userRole', userRole);
      console.log('🔍 Frontend - Rol del usuario:', userRole);
    }
    
    // Construir URL con parámetros si existen
    if (params.toString()) {
      url += `?${params.toString()}`;
    }
    
    console.log('🔍 Frontend - URL final:', url);
    
    const response = await fetch(url);
    if (!response.ok) throw new Error('Error al cargar meta-balance-reduction');
    const records = await response.json();
    
    console.log('🔍 Frontend - Registros recibidos:', records.length);
    
    return records;
  } catch (error) {
    console.error('Error al cargar meta-balance-reduction:', error);
    throw error;
  }
};

export const loadMetaVerifications = async (userCells = null, userRole = null) => {
  try {
    let url = `${API_URL}/meta-verifications`;
    const params = new URLSearchParams();
    
    // Si se proporcionan células del usuario, agregarlas como parámetro de consulta
    if (userCells && userCells.length > 0) {
      const cellsParam = userCells.join(',');
      params.append('userCells', cellsParam);
      console.log('🔍 Frontend - Cargando meta-verifications con filtro de células:', cellsParam);
    }
    
    // Agregar el rol del usuario
    if (userRole) {
      params.append('userRole', userRole);
      console.log('🔍 Frontend - Rol del usuario:', userRole);
    }
    
    // Construir URL con parámetros si existen
    if (params.toString()) {
      url += `?${params.toString()}`;
    }
    
    console.log('🔍 Frontend - URL final:', url);
    
    const response = await fetch(url);
    if (!response.ok) throw new Error('Error al cargar meta-verifications');
    const records = await response.json();
    
    console.log('🔍 Frontend - Registros recibidos:', records.length);
    
    return records;
  } catch (error) {
    console.error('Error al cargar meta-verifications:', error);
    throw error;
  }
};

export const loadMetaNoAnswer = async (userCells = null, userRole = null, userEmail = null) => {
  try {
    let url = `${API_URL}/meta-no-answer`;
    const params = new URLSearchParams();
    
    // Si se proporcionan células del usuario, agregarlas como parámetro de consulta
    if (userCells && userCells.length > 0) {
      const cellsParam = userCells.join(',');
      params.append('userCells', cellsParam);
      console.log('🔍 Frontend - Cargando meta-no-answer con filtro de células:', cellsParam);
    }
    
    // Agregar el rol del usuario
    if (userRole) {
      params.append('userRole', userRole);
      console.log('🔍 Frontend - Rol del usuario:', userRole);
    }
    
    // Agregar el email del usuario para filtrado por agente asignado
    if (userEmail) {
      params.append('userEmail', userEmail);
      console.log('🔍 Frontend - Email del usuario:', userEmail);
    }
    
    // Construir URL con parámetros si existen
    if (params.toString()) {
      url += `?${params.toString()}`;
    }
    
    console.log('🔍 Frontend - URL final:', url);
    
    const response = await fetch(url);
    if (!response.ok) throw new Error('Error al cargar meta-no-answer');
    const records = await response.json();
    
    console.log('🔍 Frontend - Registros recibidos:', records.length);
    
    return records;
  } catch (error) {
    console.error('Error al cargar meta-no-answer:', error);
    throw error;
  }
};

export const loadMetaNoContact = async (userCells = null, userRole = null) => {
  try {
    let url = `${API_URL}/meta-no-contact`;
    const params = new URLSearchParams();
    
    // Si se proporcionan células del usuario, agregarlas como parámetro de consulta
    if (userCells && userCells.length > 0) {
      const cellsParam = userCells.join(',');
      params.append('userCells', cellsParam);
      console.log('🔍 Frontend - Cargando meta-no-contact con filtro de células:', cellsParam);
    }
    
    // Agregar el rol del usuario
    if (userRole) {
      params.append('userRole', userRole);
      console.log('🔍 Frontend - Rol del usuario:', userRole);
    }
    
    // Construir URL con parámetros si existen
    if (params.toString()) {
      url += `?${params.toString()}`;
    }
    
    console.log('🔍 Frontend - URL final:', url);
    
    const response = await fetch(url);
    if (!response.ok) throw new Error('Error al cargar meta-no-contact');
    const records = await response.json();
    
    console.log('🔍 Frontend - Registros recibidos:', records.length);
    
    return records;
  } catch (error) {
    console.error('Error al cargar meta-no-contact:', error);
    throw error;
  }
};

export const loadMetaCostIncrease = async (userCells = null, userRole = null) => {
  try {
    let url = `${API_URL}/meta-cost-increase`;
    const params = new URLSearchParams();
    
    // Si se proporcionan células del usuario, agregarlas como parámetro de consulta
    if (userCells && userCells.length > 0) {
      const cellsParam = userCells.join(',');
      params.append('userCells', cellsParam);
      console.log('🔍 Frontend - Cargando meta-cost-increase con filtro de células:', cellsParam);
    }
    
    // Agregar el rol del usuario
    if (userRole) {
      params.append('userRole', userRole);
      console.log('🔍 Frontend - Rol del usuario:', userRole);
    }
    
    // Construir URL con parámetros si existen
    if (params.toString()) {
      url += `?${params.toString()}`;
    }
    
    console.log('🔍 Frontend - URL final:', url);
    
    const response = await fetch(url);
    if (!response.ok) throw new Error('Error al cargar meta-cost-increase');
    const records = await response.json();
    
    console.log('🔍 Frontend - Registros recibidos:', records.length);
    
    return records;
  } catch (error) {
    console.error('Error al cargar meta-cost-increase:', error);
    throw error;
  }
};

// ==================== FUNCIONES DE REMINDS ====================

export const loadReminds = async (userEmail = null, userRole = null) => {
  try {
    let url = `${API_URL}/reminds`;
    const params = new URLSearchParams();
    
    // Agregar el email del usuario para filtrado
    if (userEmail) {
      params.append('userEmail', userEmail);
      console.log('🔍 Frontend - Cargando reminds con filtro de email:', userEmail);
    }
    
    // Agregar el rol del usuario
    if (userRole) {
      params.append('userRole', userRole);
      console.log('🔍 Frontend - Rol del usuario:', userRole);
    }
    
    // Construir URL con parámetros si existen
    if (params.toString()) {
      url += `?${params.toString()}`;
    }
    
    console.log('🔍 Frontend - URL final:', url);
    
    const response = await fetch(url);
    if (!response.ok) throw new Error('Error al cargar reminds');
    const records = await response.json();
    
    console.log('🔍 Frontend - Reminds recibidos:', records.length);
    
    return records;
  } catch (error) {
    console.error('Error al cargar reminds:', error);
    throw error;
  }
};

export const createRemind = async (remind) => {
  try {
    // Verificar si remind es una instancia de FormData
    const isFormData = remind instanceof FormData;
    
    // Configurar headers y body según el tipo de datos
    const requestOptions = {
      method: 'POST',
      headers: isFormData ? {} : headers,
      body: isFormData ? remind : JSON.stringify(remind),
    };
    
    console.log('🚀 createRemind - Tipo de datos:', isFormData ? 'FormData' : 'JSON');
    
    const response = await fetch(`${API_URL}/reminds`, requestOptions);
    if (!response.ok) throw new Error('Error al crear remind');
    return await response.json();
  } catch (error) {
    console.error('Error al crear remind:', error);
    throw error;
  }
};

export const updateRemind = async (id, updates) => {
  try {
    // Verificar si updates es una instancia de FormData
    const isFormData = updates instanceof FormData;
    
    // Configurar headers y body según el tipo de datos
    const requestOptions = {
      method: 'PUT',
      headers: isFormData ? {} : headers,
      body: isFormData ? updates : JSON.stringify(updates),
    };
    
    const response = await fetch(`${API_URL}/reminds/${id}`, requestOptions);
    if (!response.ok) throw new Error('Error al actualizar remind');
    return await response.json();
  } catch (error) {
    console.error('Error al actualizar remind:', error);
    throw error;
  }
};

export const deleteRemind = async (id) => {
  try {
    const response = await fetch(`${API_URL}/reminds/${id}`, {
      method: 'DELETE',
      headers,
    });
    if (!response.ok) throw new Error('Error al eliminar remind');
    return await response.json();
  } catch (error) {
    console.error('Error al eliminar remind:', error);
    throw error;
  }
};

export const completeRemind = async (id, newEstado, userName) => {
  try {
    const response = await fetch(`${API_URL}/reminds/${id}/complete`, {
      method: 'PUT',
      headers,
      body: JSON.stringify({ new_estado: newEstado, user_name: userName }),
    });
    if (!response.ok) throw new Error('Error al completar remind');
    return await response.json();
  } catch (error) {
    console.error('Error al completar remind:', error);
    throw error;
  }
};

export const getRemindHistory = async (id) => {
  try {
    const response = await fetch(`${API_URL}/reminds/${id}/history`);
    if (!response.ok) throw new Error('Error al obtener historial de remind');
    return await response.json();
  } catch (error) {
    console.error('Error al obtener historial de remind:', error);
    throw error;
  }
};

export const deleteRemindPhoto = async (id, filename) => {
  try {
    const response = await fetch(`${API_URL}/reminds/${id}/fotos/${filename}`, {
      method: 'DELETE',
      headers,
    });
    if (!response.ok) throw new Error('Error al eliminar foto de remind');
    return await response.json();
  } catch (error) {
    console.error('Error al eliminar foto de remind:', error);
    throw error;
  }
};

// ==================== FUNCIONES DE SOLICITUDES DE ADS ====================

export const loadAdsRequests = async (userEmail = null, userRole = null) => {
  try {
    let url = `${API_URL}/ads-requests`;
    const params = new URLSearchParams();
    
    // Agregar el email del usuario para filtrado
    if (userEmail) {
      params.append('userEmail', userEmail);
      console.log('🔍 Frontend - Cargando ads-requests con filtro de email:', userEmail);
    }
    
    // Agregar el rol del usuario
    if (userRole) {
      params.append('userRole', userRole);
      console.log('🔍 Frontend - Rol del usuario:', userRole);
    }
    
    // Construir URL con parámetros si existen
    if (params.toString()) {
      url += `?${params.toString()}`;
    }
    
    console.log('🔍 Frontend - URL final:', url);
    
    const response = await fetch(url);
    if (!response.ok) throw new Error('Error al cargar solicitudes de ads');
    const records = await response.json();
    
    console.log('🔍 Frontend - Solicitudes de ads recibidas:', records.length);
    
    return records;
  } catch (error) {
    console.error('Error al cargar solicitudes de ads:', error);
    throw error;
  }
};

export const createAdsRequest = async (request) => {
  try {
    const response = await fetch(`${API_URL}/ads-requests`, {
      method: 'POST',
      headers,
      body: JSON.stringify(request),
    });
    if (!response.ok) throw new Error('Error al crear solicitud de ads');
    return await response.json();
  } catch (error) {
    console.error('Error al crear solicitud de ads:', error);
    throw error;
  }
};

export const updateAdsRequest = async (id, updates) => {
  try {
    const response = await fetch(`${API_URL}/ads-requests/${id}`, {
      method: 'PUT',
      headers,
      body: JSON.stringify(updates),
    });
    if (!response.ok) throw new Error('Error al actualizar solicitud de ads');
    return await response.json();
  } catch (error) {
    console.error('Error al actualizar solicitud de ads:', error);
    throw error;
  }
};

export const deleteAdsRequest = async (id) => {
  try {
    const response = await fetch(`${API_URL}/ads-requests/${id}`, {
      method: 'DELETE',
      headers,
    });
    if (!response.ok) throw new Error('Error al eliminar solicitud de ads');
    return await response.json();
  } catch (error) {
    console.error('Error al eliminar solicitud de ads:', error);
    throw error;
  }
};

export const completeAdsRequest = async (id, newEstado, userName) => {
  try {
    const response = await fetch(`${API_URL}/ads-requests/${id}/complete`, {
      method: 'PUT',
      headers,
      body: JSON.stringify({ new_estado: newEstado, user_name: userName }),
    });
    if (!response.ok) throw new Error('Error al completar solicitud de ads');
    return await response.json();
  } catch (error) {
    console.error('Error al completar solicitud de ads:', error);
    throw error;
  }
};

export const getAdsRequestHistory = async (id) => {
  try {
    const response = await fetch(`${API_URL}/ads-requests/${id}/history`);
    if (!response.ok) throw new Error('Error al obtener historial de solicitud de ads');
    return await response.json();
  } catch (error) {
    console.error('Error al obtener historial de solicitud de ads:', error);
    throw error;
  }
};
